module.exports = __webpack_public_path__ + "source-sans-pro-v10-latin-ext_latin-regular.eac8936d23eb2d5bf3bb.woff";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/accessibility/layout/fonts/source-sans-pro-v10-latin-ext_latin-regular.woff
// module id = ../../../../../src/assets/accessibility/layout/fonts/source-sans-pro-v10-latin-ext_latin-regular.woff
// module chunks = styles